import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import MakeAsyncFunction from 'react-redux-promise-listener';
import InputField from 'src/components/InputField';
import { promiseListener } from 'src/store';
import validations from './validations';

const ForgotPassword = () => (
    <div className="d-block pt-2 pl-1">
        <a href="" className="small">Esqueci minha senha</a>
    </div>
);

const FormBody = ({ handleSubmit }) => (
    <form onSubmit={handleSubmit}>                        
        <div className="pl-lg-4">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Field
                        name="current_password"
                        type="password"
                        className="form-control"
                        label="Senha Atual"
                        component={InputField}
                        after={(<ForgotPassword />)}
                    />
                </div>
                
            </div>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Field
                        name="new_password"
                        type="password"
                        className="form-control"
                        label="Nova Senha"
                        component={InputField}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <Field
                        name="password_confirmation"
                        type="password"
                        className="form-control"
                        label="Confirme a Senha"
                        placeHolder="Confirme a sua nova senha"
                        component={InputField}
                    />
                </div>
            </div>

        </div>
        <div className="text-center">
            <button type="submit" className="btn btn-success mt-4">Salvar</button>
        </div>
    </form>
);

const UserForm = () => (
    <MakeAsyncFunction
        listener={promiseListener}
        start="CHANGE_PASSWORD_SUBMIT"
        resolve="CHANGE_PASSWORD_SUCCEEDED"
        reject="CHANGE_PASSWORD_FAILED"
        >{submit => (
            <Form
                onSubmit={submit}
                validate={validations}
                render={(props) => ( <FormBody {...props} />)}
            />
        )}
    </MakeAsyncFunction>
);

export default UserForm;


// WEBPACK FOOTER //
// ./src/components/Pages/ChangePassword/Form.js